//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";

import QFabricModal from "../../q-fabric-modal";

export default {
    name: "QfMInterfaceDetails",
    components: { QFabricModal },
    props: { data: Object },
    data() {
        return {
            test: "test",
            localShow: true
        };
    },
    computed: {
        ...mapState("components", ["parsed"]),
        actions() {
            const disable = true;

            return [{ label: "Set", name: "set", disable }];
        }
    },
    methods: {
        modalAction(action) {
            if (action.simple === "hide") {
                this.localShow = false;
            } else if (action.simple === "action") {
                if (action.detailed === "set") {
                    this.localShow = false;
                }
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        }
    }
};
